module.exports = __webpack_public_path__ + "img/yf2.0e9fbba1.jpg";